import { ConsentHandler } from '@/core/data_handlers/consent';
import {
  EConsentSource,
  TConsentMap,
} from '@/core/data_handlers/consent/types';
import { Logger } from '@/shared/logger/logger';

export async function handleConsent(
  action: 'get' | 'set',
  consentMap?: TConsentMap,
  source?: EConsentSource,
) {
  Logger.info('Handling consent', action);
  if (action === 'set') {
    if (!consentMap || !source) {
      Logger.error('Consent map and source are required for setting consent');
      return { success: false };
    }
    Logger.info('Setting consent', consentMap, source);
    ConsentHandler.setConsent(consentMap, source);
    return { success: true };
  } else if (action === 'get') {
    return { data: ConsentHandler.getConsent(), success: true };
  } else {
    Logger.error('Invalid consent action');
    return { success: false };
  }
}
